import { render, staticRenderFns } from "./DiseaseKeShiPage.vue?vue&type=template&id=fa8fb454"
import script from "./DiseaseKeShiPage.vue?vue&type=script&lang=js"
export * from "./DiseaseKeShiPage.vue?vue&type=script&lang=js"
import style0 from "./DiseaseKeShiPage.vue?vue&type=style&index=0&id=fa8fb454&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports